/**  Batch  */
import { CHANGE_BATCH_STATUS_APPROVE, CHANGE_BATCH_STATUS_UNPAID } from './batch.types';

export const changeBatchStatusToApprove = (id) => {
  return {
    type: CHANGE_BATCH_STATUS_APPROVE,
    payload: { id },
  };
};

export const changeBatchStatusToUnPaid = (id) => {
  return {
    type: CHANGE_BATCH_STATUS_UNPAID,
    payload: { id },
  };
};

/** End */

